<template>
    <div class="date-range-wrapper w-full h-full">
        <input type="text" ref="input" style="box-shadow: none !important;" :class="inputClass" :value="displayValue"
            :append-to-body="false" readonly placeholder="Select Date" />
    </div>
</template>

<script>
import $ from "jquery";
import "daterangepicker";
import moment from "moment";
import "daterangepicker/daterangepicker.css";

export default {
    name: "DateRangePicker",
    props: {
        value: {
            type: Array,
            default: () => [moment().startOf('month'), moment()],
        },
        disableFuture: {
            type: Boolean,
            default: false,
        },
        disablePast: {
            type: Boolean,
            default: false,
        },
        disablePastDate: {
            type: Object,
            default: () => moment(),
        },
        inputClass: {
            type: String,
            default: 'cursor-pointer px-[10px] py-[5px] rounded-full text-[14px] 2xl:text-[16px] w-full border border-customGray focus:outline-none disabled:bg-customGray disabled:cursor-not-allowed'
        },
        isMasterReporting: {
            type: Boolean,
            default: false,
        },
        parentEl: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            startDate: null,
            endDate: null,
        };
    },
    computed: {
        displayValue() {
            if (!this.startDate || !this.endDate) return 'Select Date';
            return `${this.startDate} - ${this.endDate}`;
        },
    },
    mounted() {
        this.setDefaultDates();

        if (this.isMasterReporting) {
            this.initMasterReportingDatePicker()
        }
        else {
            this.initDatePicker();
        }

        // ✅ DESKTOP ONLY (mouse / trackpad)
        if (window.matchMedia('(pointer: fine)').matches) {
            document.addEventListener("scroll", this.handleScroll, true);
        }
    },

    beforeUnmount() {
        $(document).off(`mousedown.daterangepicker-${this._uid}`);
        if (window.matchMedia('(pointer: fine)').matches) {
            document.removeEventListener("scroll", this.handleScroll, true);
        }

        const picker = $(this.$refs.input).data("daterangepicker");
        if (picker) {
            picker.remove();
        }
    },

    methods: {

        clearDate() {
            this.startDate = '';
            this.endDate = '';

            const picker = $(this.$refs.input).data("daterangepicker");
            if (picker) {
                picker.setStartDate(moment());
                picker.setEndDate(moment());
                picker.element.val('Select Date');
                const container = $(picker.container);
                container.find('.ranges li').removeClass('active');
                container.find('.drp-calendar td').removeClass('active in-range start-date end-date');
                container.removeClass('show-calendar');
            }

            this.$emit('input', []);
            this.$emit('change', {
                label: 'Select Date',
                dates: [],
            });
        },

        setDefaultDates() {
            if (!this.value || (this.value && this.value.length <= 0)) {
                this.value = [moment().startOf("month").format("MM/DD/YYYY"), moment().format("MM/DD/YYYY")]
            }
            this.startDate = this.value[0] || moment().startOf("month").format("MM/DD/YYYY");
            this.endDate = this.value[1] || moment().format("MM/DD/YYYY");
        },

        initDatePicker() {
            const self = this;

            let option = {
                startDate: moment(this.startDate, "MM/DD/YYYY"),
                endDate: moment(this.endDate, "MM/DD/YYYY"),
                autoApply: true,
                showDropdowns: false,
                showCustomRangeLabel: false,
                showCalendarInputs: false,
                parentEl: ".content-wrapper",
                // parentEl: ".masterReporting ",
                locale: {
                    format: "MM/DD/YYYY",
                    applyLabel: "OK",
                    cancelLabel: "Cancel",
                },
                maxDate: this.disableFuture ? moment() : false,
                minDate: this.disablePast ? this.disablePastDate : false,
            }

            if (!this.disablePast) {
                option['showCustomRangeLabel'] = true
                option['ranges'] = {
                    "Today": [moment(), moment()],
                    "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "Month to Date": [moment().startOf('month'), moment()],
                    "Year to Date": [moment().startOf('year'), moment()],
                    "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "month").endOf("month"),
                    ],
                }
            }

            $(this.$refs.input).daterangepicker(
                option,
                function (start, end, label) {
                    self.startDate = start.format("MM/DD/YYYY");
                    self.endDate = end.format("MM/DD/YYYY");
                    // Emit event with range label + dates
                    self.$emit("change", {
                        label: label || 'Custom Range',
                        dates: [self.startDate, self.endDate],
                    });
                    self.$emit("input", [self.startDate, self.endDate]); // normal v-model emit
                }
            );

        },

        initMasterReportingDatePicker() {
            const self = this;
            const parentContainer = this.$el.closest('.masterReporting, .masterReportingHead');

            let option = {
                alwaysShowCalendars: false,
                startDate: moment(this.startDate, "MM/DD/YYYY"),
                endDate: moment(this.endDate, "MM/DD/YYYY"),
                autoApply: true,
                showDropdowns: false,
                showCustomRangeLabel: false,
                showCalendarInputs: false,
                parentEl: parentContainer || 'body',
                locale: {
                    format: "MM/DD/YYYY",
                    applyLabel: "OK",
                    cancelLabel: "Cancel",
                },
                maxDate: this.disableFuture ? moment() : false,
                minDate: this.disablePast ? this.disablePastDate : false,
            }

            if (!this.disablePast) {
                option['showCustomRangeLabel'] = true
                option['ranges'] = {
                    "Today": [moment(), moment()],
                    "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "Month to Date": [moment().startOf('month'), moment()],
                    "Year to Date": [moment().startOf('year'), moment()],
                    "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "month").endOf("month"),
                    ],
                }
            }

            $(this.$refs.input).daterangepicker(
                option,
                function (start, end, label) {
                    self.startDate = start.format("MM/DD/YYYY");
                    self.endDate = end.format("MM/DD/YYYY");
                    // Emit event with range label + dates
                    self.$emit("change", {
                        label: label || 'Custom Range',
                        dates: [self.startDate, self.endDate],
                    });
                    self.$emit("input", [self.startDate, self.endDate]); // normal v-model emit
                }
            );

            // Remove auto-active range only if no date is selected
            $(this.$refs.input).on('show.daterangepicker', function (ev, drp) {
                // Check if startDate or endDate are empty
                const hasSelectedDates =
                    drp.startDate && drp.endDate &&
                    drp.element.val() &&
                    drp.element.val() != 'Select Date';

                if (!hasSelectedDates) {
                    const container = $(drp.container);
                    container.find('.ranges li').removeClass('active');
                }
            });
        },

        // 👉 Add this method to open the date picker
        // ✅ New method to programmatically open the date picker
        openDatePicker() {
            if (this.$refs.input) {
                const picker = $(this.$refs.input).data("daterangepicker");
                if (picker && !picker.isShowing) {
                    picker.show(); // This will open the daterangepicker
                }
            }
        },

        handleScroll() {
            const picker = $(this.$refs.input).data("daterangepicker");
            if (picker && picker.isShowing) {
                picker.hide();
            }
        },
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && newVal.length === 2) {
                    this.startDate = newVal[0];
                    this.endDate = newVal[1];

                    this.$nextTick(() => {
                        const picker = $(this.$refs.input).data("daterangepicker");
                        if (picker) {
                            picker.setStartDate(moment(newVal[0], "MM/DD/YYYY"));
                            picker.setEndDate(moment(newVal[1], "MM/DD/YYYY"));
                        } else {
                            console.error("Daterangepicker instance not found on input");
                        }
                    });
                }
            },
            deep: true,
            immediate: true,
        },
    },

    unmounted() {
        document.removeEventListener("scroll", this.handleScroll, true);

        const picker = $(this.$refs.input).data("daterangepicker");
        if (picker) {
            picker.remove();
        }
    },

};
</script>
<style>
.daterangepicker {
    z-index: 9;
}
</style>